import { OsUtil } from '../../../basic/OsUtil';
import { CompareView } from '../../../compare/CompareRevisions';
import { FolderDetails } from '../../../components/folder-details/FolderDetails';
import t from '../../../i18n/I18n';
import LazyLoad from '../../../lazyload/LazyLoad';
import AddToCollectionModal from '../../../modals/add/AddToCollectionModal';
import ArchiveDetailsModal from '../../../modals/archive/ArchiveDetailsModal';
import ArchiveModal from '../../../modals/archive/ArchiveModal';
import NewBinModal from '../../../modals/collections/new-bin-modal/NewBinModal';
import DeleteAssetsModal from '../../../modals/delete/DeleteAssetsModal';
import EditAssetsModal from '../../../modals/edit/EditAssetsModal';
import ArchiveExternalModal from '../../../modals/manageexternal/ArchiveExternalModal';
import RestoreExternalModal from '../../../modals/manageexternal/RestoreExternalModal';
import CollectionsOperationModal, { SaveCollectionModal } from '../../../modals/remove/CollectionsOperationModal';
import RemoveAssetsModal from '../../../modals/remove/RemoveAssetsModal';
import RenameModal from '../../../modals/rename/RenameModal';
import RestoreModal from '../../../modals/restore/RestoreModal';
import AddSpotlightModal from '../../../modals/spotlight/AddSpotlightModal';
import S3Upload from '../../../s3-operation/S3Upload';
import SmartCopyLinkDialog from '../../../smart-copy-link/SmartCopyLinkDialog';
import InfoModal from '../../../tabs/browse-external/InfoModal';
import { UIActions } from '../../../util/Constants';
import { ProgressDialog } from '../../progress-dialog/ProgressDialog';
import MoveToBinSubMenu from '../options/collections/MoveToBinSubMenu';
import { CM_ACTIONS } from './actions_CM';
import { CM_PREDICATES } from './predicates_CM';

const ShareAssetsModal = LazyLoad(() => import('../../../modals/share/ShareAssetsModal'));

const fileterProps = (props: object = {}, relativeProps: Array<string> = [], additionalProps: Array<object> = []) => {
  const args = {};
  relativeProps.forEach((key) => (args[key] = props[key]));
  return { ...args, ...additionalProps };
};

const ARCHIVE_PROXY_KEYS = [
  //"ARCHIVE_LOWRES",
  'ARCHIVE_MIDRES',
  'ARCHIVE_HIRES'
];

const RESTORE_PROXY_KEYS = [
  //"RESTORE_LOWRES",
  'RESTORE_MIDRES',
  'RESTORE_HIRES'
];

const GLACIER_PROXY_KEYS = [
  //"GLACIER_LOWRES",
  'GLACIER_MIDRES',
  'GLACIER_HIRES'
];

const CLEANUP_PROXY_KEYS = [
  //"CLEAN_UP_LOWRES",
  'CLEAN_UP_MIDRES',
  'CLEAN_UP_HIRES'
];

const MANAGE_EXTERNAL_FILE_KEYS = [
  {
    key: UIActions.REMOVE_FROM_MEDIA_STORE,
    value: CLEANUP_PROXY_KEYS,
    icons: { icon: 'images/icons_purge.svg', iconOnHover: 'hoverIcons/context/icons_purge.svg' }
  },
  {
    key: UIActions.COPY_FROM_MEDIA_STORE_TO_S3,
    value: ARCHIVE_PROXY_KEYS,
    icons: { icon: 'images/icons_copyMS2s3.svg', iconOnHover: 'hoverIcons/context/icons_copyMS2s3.svg' }
  },
  {
    key: UIActions.COPY_FROM_S3_TO_MEDIA_STORE,
    value: RESTORE_PROXY_KEYS,
    icons: { icon: 'images/icons_copys32MS.svg', iconOnHover: 'hoverIcons/context/icons_copys32MS.svg' }
  },
  {
    key: UIActions.COPY_FROM_BACKUP_TO_S3,
    value: GLACIER_PROXY_KEYS,
    icons: { icon: 'images/icons_copyMS2s3.svg', iconOnHover: 'hoverIcons/context/icons_copyMS2s3.svg' }
  }
];

const MORE_KEYS = [
  UIActions.ADD_TO_SPOTLIGHT,
  UIActions.ADD_TO_FAVORITES,
  UIActions.REMOVE_FROM_FAVORITES,
  UIActions.REVEAL_IN_EXPLORER,
  UIActions.VIEW_IN_ASSET_BROWSER,
  UIActions.COPY_ASSET_ID,
  UIActions.COPY_ASSET_PATH,
  UIActions.COPY_URL,
  UIActions.FOLDER_DETAILS,
  UIActions.ARCHIVE_DETAILS
];

const ARGS_CM = {
  PROPS: {
    ASSET: 'asset',
    ASSETS: 'assets',
    EXT_DETAILS: 'extDetails',
    FETCH_ASSET: 'fetchAssets',
    GET_PROCESS_ON_QUERY: 'getProgressOnQuery',
    LOADED: 'loaded',
    MESSAGE: 'message',
    MODAL: 'modal',
    ON_CLOSE: 'onClose',
    ON_DELETE_SUCESS: 'onDeleteSuccess',
    ON_REFRESH_PWD: 'onRefreshPWD',
    ON_REFRESH: 'onRefresh',
    CLOSE_CONTEXT_MENU: 'closeContextMenu',
    SET_MODAL: 'setModal',
    TITLE: 'title',
    EXCLUDED_ACTIONS_LIST: 'excludedActions',
    SET_SHOW_INFO_MODAL: 'setShowInfoMetadata',
    COLLECTION: 'collection',
    COLLECTIONS: 'collections',
    SELECTED_COLLECTIONS: 'selectedCollections',
    RELOAD_COLLECTION: 'reloadCollection'
  },
  MODAL: {
    ADD_TO_COLLECTION: UIActions.ADD_TO_COLLECTION,
    ADD_TO_SPOTLIGHT: UIActions.ADD_TO_SPOTLIGHT,
    ARCHIVE_DETAILS: UIActions.ARCHIVE_DETAILS,
    ARCHIVE: UIActions.ARCHIVE,
    CLEAN_UP_HIRES: 'CLEAN_UP_HIRES',
    CLEAN_UP_MIDRES: 'CLEAN_UP_MIDRES',
    CLEAN_UP_LOWRES: 'CLEAN_UP_LOWRES',
    ARCHIVE_LOWRES: 'ARCHIVE_LOWRES',
    ARCHIVE_MIDRES: 'ARCHIVE_MIDRES',
    ARCHIVE_HIRES: 'ARCHIVE_HIRES',
    RESTORE_LOWRES: 'RESTORE_LOWRES',
    RESTORE_MIDRES: 'RESTORE_MIDRES',
    RESTORE_HIRES: 'RESTORE_HIRES',
    COMPARE_VIEW: UIActions.COMPARE_VIEW,
    DELETE: UIActions.DELETE,
    SHARE_VIA_EMAIL: UIActions.SHARE_VIA_EMAIL,
    EDIT_ASSETS: UIActions.EDIT_METADATA,
    FOLDER_DETAILS: UIActions.FOLDER_DETAILS,
    INFO: UIActions.ASSET_DETAILS,
    PROGRESS_DIALOG: 'PROGRESS_DIALOG',
    PURGE: UIActions.PURGE,
    REMOVE_ASSETS: UIActions.REMOVE_FROM_COLLECTION,
    RENAME: UIActions.RENAME,
    RESTORE: UIActions.RESTORE,
    S3UPLOAD: 'S3UPLOAD',
    SMART_COPY: UIActions.SMART_COPY,
    SMART_LINK: UIActions.SMART_LINK,
    CREATE_BIN: UIActions.CREATE_BIN,
    RENAME_BIN: UIActions.RENAME_BIN,
    RENAME_COLLECTION: UIActions.RENAME_COLLECTION,
    HIDE_COLLECTION: UIActions.HIDE_COLLECTION,
    UNHIDE_COLLECTION: UIActions.UNHIDE_COLLECTION,
    DELETE_COLLECTION: UIActions.DELETE_COLLECTION,
    DELETE_BIN: UIActions.DELETE_BIN
  }
};

export const DATA_CM = {
  PORTALS: {
    [UIActions.ADD_TO_COLLECTION]: {
      MODAL: ARGS_CM.MODAL.ADD_TO_COLLECTION,
      COMPONENT: AddToCollectionModal,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.ON_CLOSE],
      ADDITIONAL_PROPS: {}
    },
    [UIActions.ADD_TO_SPOTLIGHT]: {
      MODAL: ARGS_CM.MODAL.ADD_TO_SPOTLIGHT,
      COMPONENT: AddSpotlightModal,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.ASSET, ARGS_CM.PROPS.ON_CLOSE],
      ADDITIONAL_PROPS: {}
    },
    [UIActions.ARCHIVE_DETAILS]: {
      MODAL: ARGS_CM.MODAL.ARCHIVE_DETAILS,
      COMPONENT: ArchiveDetailsModal,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.ON_CLOSE],
      ADDITIONAL_PROPS: {}
    },
    [UIActions.ARCHIVE]: {
      MODAL: ARGS_CM.MODAL.ARCHIVE,
      COMPONENT: ArchiveModal,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.ON_CLOSE, ARGS_CM.PROPS.ON_REFRESH_PWD],
      ADDITIONAL_PROPS: {}
    },
    CLEAN_UP_HIRES: {
      MODAL: ARGS_CM.MODAL.CLEAN_UP_HIRES,
      COMPONENT: ArchiveExternalModal,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.ON_CLOSE, ARGS_CM.PROPS.ON_REFRESH_PWD],
      ADDITIONAL_PROPS: {}
    },
    CLEAN_UP_MIDRES: {
      MODAL: ARGS_CM.MODAL.CLEAN_UP_MIDRES,
      COMPONENT: ArchiveExternalModal,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.ON_CLOSE, ARGS_CM.PROPS.ON_REFRESH_PWD],
      ADDITIONAL_PROPS: {}
    },
    CLEAN_UP_LOWRES: {
      MODAL: ARGS_CM.MODAL.CLEAN_UP_LOWRES,
      COMPONENT: ArchiveExternalModal,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.ON_CLOSE, ARGS_CM.PROPS.ON_REFRESH_PWD],
      ADDITIONAL_PROPS: {}
    },
    ARCHIVE_LOWRES: {
      MODAL: ARGS_CM.MODAL.ARCHIVE_LOWRES,
      COMPONENT: ArchiveExternalModal,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.ON_CLOSE, ARGS_CM.PROPS.ON_REFRESH_PWD],
      ADDITIONAL_PROPS: {}
    },
    ARCHIVE_MIDRES: {
      MODAL: ARGS_CM.MODAL.ARCHIVE_MIDRES,
      COMPONENT: ArchiveExternalModal,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.ON_CLOSE, ARGS_CM.PROPS.ON_REFRESH_PWD],
      ADDITIONAL_PROPS: {}
    },
    ARCHIVE_HIRES: {
      MODAL: ARGS_CM.MODAL.ARCHIVE_HIRES,
      COMPONENT: ArchiveExternalModal,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.ON_CLOSE, ARGS_CM.PROPS.ON_REFRESH_PWD],
      ADDITIONAL_PROPS: {}
    },
    RESTORE_LOWRES: {
      MODAL: ARGS_CM.MODAL.RESTORE_LOWRES,
      COMPONENT: RestoreExternalModal,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.ON_CLOSE, ARGS_CM.PROPS.ON_REFRESH_PWD],
      ADDITIONAL_PROPS: {}
    },
    RESTORE_MIDRES: {
      MODAL: ARGS_CM.MODAL.RESTORE_MIDRES,
      COMPONENT: RestoreExternalModal,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.ON_CLOSE, ARGS_CM.PROPS.ON_REFRESH_PWD],
      ADDITIONAL_PROPS: {}
    },
    RESTORE_HIRES: {
      MODAL: ARGS_CM.MODAL.RESTORE_HIRES,
      COMPONENT: RestoreExternalModal,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.ON_CLOSE, ARGS_CM.PROPS.ON_REFRESH_PWD],
      ADDITIONAL_PROPS: {}
    },
    BLANK: { MODAL: null },
    [UIActions.COMPARE_VIEW]: {
      MODAL: ARGS_CM.MODAL.COMPARE_VIEW,
      COMPONENT: CompareView,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.ON_CLOSE],
      ADDITIONAL_PROPS: {}
    },
    [UIActions.DELETE]: {
      MODAL: ARGS_CM.MODAL.DELETE,
      COMPONENT: DeleteAssetsModal,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.ON_CLOSE, ARGS_CM.PROPS.ON_DELETE_SUCESS],
      ADDITIONAL_PROPS: { actionLabel: t('DELETE_LABEL') }
    },
    [UIActions.EDIT_METADATA]: {
      MODAL: ARGS_CM.MODAL.EDIT_ASSETS,
      COMPONENT: EditAssetsModal,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.ON_CLOSE],
      ADDITIONAL_PROPS: {}
    },
    [UIActions.FOLDER_DETAILS]: {
      MODAL: ARGS_CM.MODAL.FOLDER_DETAILS,
      COMPONENT: FolderDetails,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.ON_CLOSE],
      ADDITIONAL_PROPS: {}
    },
    [UIActions.ASSET_DETAILS]: {
      MODAL: ARGS_CM.MODAL.INFO,
      COMPONENT: InfoModal,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.EXT_DETAILS, ARGS_CM.PROPS.ON_CLOSE],
      ADDITIONAL_PROPS: {}
    },
    PROGRESS_DIALOG: {
      MODAL: ARGS_CM.MODAL.PROGRESS_DIALOG,
      COMPONENT: ProgressDialog,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.ON_CLOSE, ARGS_CM.PROPS.MESSAGE, ARGS_CM.PROPS.LOADED],
      ADDITIONAL_PROPS: { isRunningBackground: false, isCancelAble: false }
    },
    [UIActions.PURGE]: {
      MODAL: ARGS_CM.MODAL.PURGE,
      COMPONENT: DeleteAssetsModal,
      PROPS: [
        ARGS_CM.PROPS.MODAL,
        ARGS_CM.PROPS.ASSETS,
        ARGS_CM.PROPS.ON_CLOSE,
        ARGS_CM.PROPS.ON_DELETE_SUCESS,
        ARGS_CM.PROPS.GET_PROCESS_ON_QUERY
      ],
      ADDITIONAL_PROPS: { actionLabel: t('PURGE_MENU') }
    },
    [UIActions.REMOVE_FROM_COLLECTION]: {
      MODAL: ARGS_CM.MODAL.REMOVE_ASSETS,
      COMPONENT: RemoveAssetsModal,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.ON_CLOSE, ARGS_CM.PROPS.ON_DELETE_SUCESS],
      ADDITIONAL_PROPS: {}
    },
    [UIActions.RENAME]: {
      MODAL: ARGS_CM.MODAL.RENAME,
      COMPONENT: RenameModal,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.ASSET, ARGS_CM.PROPS.ON_CLOSE, ARGS_CM.PROPS.FETCH_ASSET],
      ADDITIONAL_PROPS: {}
    },
    [UIActions.SHARE_VIA_EMAIL]: {
      MODAL: ARGS_CM.MODAL.SHARE_VIA_EMAIL,
      COMPONENT: ShareAssetsModal,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.ON_CLOSE, ARGS_CM.PROPS.FETCH_ASSET],
      ADDITIONAL_PROPS: {}
    },
    [UIActions.RESTORE]: {
      MODAL: ARGS_CM.MODAL.RESTORE,
      COMPONENT: RestoreModal,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.ON_CLOSE, ARGS_CM.PROPS.ON_REFRESH_PWD],
      ADDITIONAL_PROPS: {}
    },
    S3UPLOAD: {
      MODAL: ARGS_CM.MODAL.S3UPLOAD,
      COMPONENT: S3Upload,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.EXT_DETAILS, ARGS_CM.PROPS.ON_CLOSE, ARGS_CM.PROPS.TITLE],
      ADDITIONAL_PROPS: {}
    },
    [UIActions.SMART_COPY]: {
      MODAL: ARGS_CM.MODAL.SMART_COPY,
      COMPONENT: SmartCopyLinkDialog,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.ON_CLOSE],
      ADDITIONAL_PROPS: { isSmartCopy: true }
    },
    [UIActions.SMART_LINK]: {
      MODAL: ARGS_CM.MODAL.SMART_LINK,
      COMPONENT: SmartCopyLinkDialog,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.ON_CLOSE],
      ADDITIONAL_PROPS: { isSmartCopy: false }
    },
    [UIActions.CREATE_BIN]: {
      MODAL: ARGS_CM.MODAL.CREATE_BIN,
      COMPONENT: NewBinModal,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.COLLECTIONS, ARGS_CM.PROPS.ON_CLOSE, ARGS_CM.PROPS.RELOAD_COLLECTION],
      ADDITIONAL_PROPS: {}
    },
    [UIActions.RENAME_COLLECTION]: {
      MODAL: ARGS_CM.MODAL.RENAME_COLLECTION,
      COMPONENT: SaveCollectionModal,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.COLLECTIONS, ARGS_CM.PROPS.ON_CLOSE],
      ADDITIONAL_PROPS: { title: UIActions.RENAME_COLLECTION, save: CM_ACTIONS.renameCollection }
    },
    [UIActions.RENAME_BIN]: {
      MODAL: ARGS_CM.MODAL.RENAME_BIN,
      COMPONENT: SaveCollectionModal,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.COLLECTIONS, ARGS_CM.PROPS.ON_CLOSE],
      ADDITIONAL_PROPS: { title: UIActions.RENAME_BIN, save: CM_ACTIONS.renameCollection }
    },
    [UIActions.HIDE_COLLECTION]: {
      MODAL: ARGS_CM.MODAL.HIDE_COLLECTION,
      COMPONENT: CollectionsOperationModal,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.COLLECTIONS, ARGS_CM.PROPS.ON_CLOSE, ARGS_CM.PROPS.RELOAD_COLLECTION],
      ADDITIONAL_PROPS: { operation: 'HIDE' }
    },
    [UIActions.UNHIDE_COLLECTION]: {
      MODAL: ARGS_CM.MODAL.UNHIDE_COLLECTION,
      COMPONENT: CollectionsOperationModal,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.COLLECTIONS, ARGS_CM.PROPS.ON_CLOSE, ARGS_CM.PROPS.RELOAD_COLLECTION],
      ADDITIONAL_PROPS: { operation: 'UNHIDE' }
    },
    [UIActions.DELETE_COLLECTION]: {
      MODAL: ARGS_CM.MODAL.DELETE_COLLECTION,
      COMPONENT: CollectionsOperationModal,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.COLLECTIONS, ARGS_CM.PROPS.ON_CLOSE, ARGS_CM.PROPS.RELOAD_COLLECTION],
      ADDITIONAL_PROPS: { operation: 'DELETE' }
    },
    [UIActions.DELETE_BIN]: {
      MODAL: ARGS_CM.MODAL.DELETE_BIN,
      COMPONENT: CollectionsOperationModal,
      PROPS: [ARGS_CM.PROPS.MODAL, ARGS_CM.PROPS.COLLECTIONS, ARGS_CM.PROPS.ON_CLOSE, ARGS_CM.PROPS.RELOAD_COLLECTION],
      ADDITIONAL_PROPS: { operation: 'DELETE' }
    }
  },
  FUNCTIONS: {
    fileterProps: fileterProps
  },

  OPTIONS: {
    [UIActions.ADD_TO_COLLECTION]: {
      ON_Click: CM_ACTIONS.onSetModalAction,
      LABEL: 'ADD_TO_COLLECTION',
      ICON: 'images/icons_addToCol.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_addToCol.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.SET_MODAL, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowAddToCollection
    },
    [UIActions.ADD_TO_SPOTLIGHT]: {
      ON_Click: CM_ACTIONS.onSetModalAction,
      LABEL: 'ADD_TO_SPOTLIGHT',
      ICON: 'images/icons_addToSpotlight.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_addToSpotlight.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.SET_MODAL, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowAddToSpotLight
    },
    [UIActions.ARCHIVE_DETAILS]: {
      ON_Click: CM_ACTIONS.onSetModalAction,
      LABEL: 'ARCHIVE_DETAILS',
      ICON: 'images/icons_archiveDetails.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_archiveDetails.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.SET_MODAL, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowArchiveDetailsOption
    },
    [UIActions.ASSET_DETAILS]: {
      ON_Click: CM_ACTIONS.onSetModalAction,
      LABEL: 'DETAILS',
      ICON: 'images/icons_fileDetails.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_fileDetails.svg',
      ARGS: [ARGS_CM.PROPS.SET_MODAL, ARGS_CM.PROPS.EXT_DETAILS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowDetails
    },
    [UIActions.ARCHIVE]: {
      ON_Click: CM_ACTIONS.onArchiveLowResAndDirect,
      LABEL: 'ARCHIVE_TEXT',
      ICON: 'images/icons_archive.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_archive.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowArchiveOption
    },
    [t('MANAGE_EXTERNAL_ASSET')]: {
      LABEL: t('MANAGE_EXTERNAL_ASSET'),
      ICON: 'images/icons_externalAsset.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_externalAsset.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowManageExternalOptions
    },
    [UIActions.REMOVE_FROM_MEDIA_STORE]: {
      LABEL: 'REMOVE_FROM_MEDIA_STORES',
      ICON: 'images/icons_purge.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_purge.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowRemoveFromMediaStore
    },
    CLEAN_UP_LOWRES: {
      ON_Click: CM_ACTIONS.onCleanUpLowRes,
      LABEL: 'LOW_RESOLUTION',
      ICON: 'images/icons_purge.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_purge.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowLowResRemoveFromMediaStore
    },
    CLEAN_UP_MIDRES: {
      ON_Click: CM_ACTIONS.onCleanUpMidRes,
      LABEL: 'MID_RESOLUTION',
      ICON: 'images/icons_purge.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_purge.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowMidResRemoveFromMediaStore
    },
    CLEAN_UP_HIRES: {
      ON_Click: CM_ACTIONS.onCleanUpHiRes,
      LABEL: 'HIGH_RESOLUTION',
      ICON: 'images/icons_purge.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_purge.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowHiResRemoveFromMediaStore
    },
    [UIActions.COPY_FROM_MEDIA_STORE_TO_S3]: {
      LABEL: 'COPY_FROM_MEDIA_STORES_TO_ARCHIVES',
      ICON: 'images/icons_copyMS2s3.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_copyMS2s3.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowCopyFromMediaStore
    },
    ARCHIVE_LOWRES: {
      ON_Click: CM_ACTIONS.onArchiveLowResAndDirect,
      LABEL: 'LOW_RESOLUTION',
      ICON: 'images/icons_copyMS2s3.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_copyMS2s3.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowLowResCopyFromMediaStore
    },
    ARCHIVE_MIDRES: {
      ON_Click: CM_ACTIONS.onArchiveMidRes,
      LABEL: 'MID_RESOLUTION',
      ICON: 'images/icons_copyMS2s3.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_copyMS2s3.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowMidResCopyFromMediaStore
    },
    ARCHIVE_HIRES: {
      ON_Click: CM_ACTIONS.onArchiveHiRes,
      LABEL: 'HIGH_RESOLUTION',
      ICON: 'images/icons_copyMS2s3.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_copyMS2s3.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowHiResCopyFromMediaStore
    },
    [UIActions.COPY_FROM_S3_TO_MEDIA_STORE]: {
      LABEL: 'COPY_FROM_ARCHIVES_TO_MEDIA_STORES',
      ICON: 'images/icons_copys32MS.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_copys32MS.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowCopyToMediaStore
    },
    RESTORE_LOWRES: {
      ON_Click: CM_ACTIONS.onRestoreLowResAndDirect,
      LABEL: 'LOW_RESOLUTION',
      ICON: 'images/icons_copys32MS.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_copys32MS.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowLowResCopyToMediaStore
    },
    RESTORE_MIDRES: {
      ON_Click: CM_ACTIONS.onRestoreMidRes,
      LABEL: 'MID_RESOLUTION',
      ICON: 'images/icons_copys32MS.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_copys32MS.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowMidResCopyToMediaStore
    },
    RESTORE_HIRES: {
      ON_Click: CM_ACTIONS.onRestoreHiRes,
      LABEL: 'HIGH_RESOLUTION',
      ICON: 'images/icons_copys32MS.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_copys32MS.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowHiResCopyToMediaStore
    },
    [UIActions.COPY_FROM_BACKUP_TO_S3]: {
      LABEL: 'COPY_FROM_BACKUP_TO_ARCHIVES',
      ICON: 'images/icons_copyMS2s3.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_copyMS2s3.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowCopyFromBackToS3
    },
    GLACIER_LOWRES: {
      ON_Click: CM_ACTIONS.onCopyLowResFromBackupToS3,
      LABEL: 'LOW_RESOLUTION',
      ICON: 'images/icons_copyMS2s3.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_copyMS2s3.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowLowResCopyFromBackToS3
    },
    GLACIER_MIDRES: {
      ON_Click: CM_ACTIONS.onCopyMidResFromBackupToS3,
      LABEL: 'MID_RESOLUTION',
      ICON: 'images/icons_copyMS2s3.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_copys32MS.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowMidResCopyFromBackToS3
    },
    GLACIER_HIRES: {
      ON_Click: CM_ACTIONS.onCopyHiResFromBackupToS3,
      LABEL: 'HIGH_RESOLUTION',
      ICON: 'images/icons_copyMS2s3.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_copys32MS.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.SET_MODAL, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowHiResCopyFromBackToS3
    },
    [UIActions.COMPARE_VIEW]: {
      ON_Click: CM_ACTIONS.onSetModalAction,
      LABEL: 'COMPARE_BOTH',
      ICON: 'images/icons_compare.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_compare.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.SET_MODAL, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowCompareViewMenu
    },
    [UIActions.COPY_ASSET_ID]: {
      ON_Click: CM_ACTIONS.onCopyAssetId,
      LABEL: 'COPY_ASSET_ID',
      ICON: 'images/icons_copy.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_copy.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowCopyAssetID
    },
    [UIActions.COPY_ASSET_PATH]: {
      ON_Click: CM_ACTIONS.onCopyAssetPath,
      LABEL: 'COPY_ASSET_PATH',
      ICON: 'images/icons_copy.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_copy.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowCopyAssetPath
    },
    [UIActions.COPY_URL]: {
      ON_Click: CM_ACTIONS.onCopyAssetURL,
      LABEL: 'COPY_ASSET_URL',
      ICON: 'images/icons_copy.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_copy.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowCopyAssetURL
    },
    [UIActions.DELETE]: {
      ON_Click: CM_ACTIONS.onSetModalAction,
      LABEL: 'DELETE_LABEL',
      ICON: 'images/icons_delete.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_delete.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.SET_MODAL, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowDelete
    },
    [UIActions.SHARE_VIA_EMAIL]: {
      ON_Click: CM_ACTIONS.onSetModalAction,
      LABEL: 'Share via E-mail',
      ICON: 'images/share_via_email.svg',
      ICON_On_Hover: 'hoverIcons/context/share_via_email.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.SET_MODAL, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowShareable
    },
    [UIActions.EDIT_METADATA]: {
      ON_Click: CM_ACTIONS.OnEditMetadata,
      LABEL: 'EDIT_METADATA',
      ICON: 'images/icons_editMetadata.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_editMetadata.svg',
      ARGS: [
        ARGS_CM.PROPS.ASSETS,
        ARGS_CM.PROPS.SET_MODAL,
        ARGS_CM.PROPS.CLOSE_CONTEXT_MENU,
        ARGS_CM.PROPS.SET_SHOW_INFO_MODAL
      ],
      PREDICATES: CM_PREDICATES.isShowEditMetadata
    },
    [UIActions.EDIT_MENU]: {
      ON_Click: CM_ACTIONS.onEdit,
      LABEL: 'EDIT_MENU',
      ICON: 'images/icons_edit.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_edit.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowOpenMenu
    },
    [UIActions.FOLDER_DETAILS]: {
      ON_Click: CM_ACTIONS.onSetModalAction,
      LABEL: 'FOLDER_DETAILS.FOLDER_DETAILS_OPTION',
      ICON: 'images/icons_folderDetails.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_folderDetails.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.SET_MODAL, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowFolderDetails
    },
    INFO: {
      ON_Click: CM_ACTIONS.onSetModalAction,
      LABEL: 'DETAILS',
      ICON: 'images/icons_fileDetails.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_fileDetails.svg',
      ARGS: [ARGS_CM.PROPS.EXT_DETAILS, ARGS_CM.PROPS.SET_MODAL, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowDetails
    },
    [UIActions.LOCK]: {
      ON_Click: CM_ACTIONS.onLock,
      LABEL: 'LOCK',
      ICON: 'images/icons_lock.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_lock.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.GET_PROCESS_ON_QUERY, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowLock
    },
    [UIActions.VIEW_ASSET]: {
      ON_Click: CM_ACTIONS.onOpen,
      LABEL: 'OPEN_MENU',
      ICON: 'images/icons_open.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_open.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowOpenMenu
    },
    [UIActions.PURGE]: {
      ON_Click: CM_ACTIONS.onSetModalAction,
      LABEL: 'PURGE_MENU',
      ICON: 'images/icons_purge.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_purge.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.SET_MODAL, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowPurge
    },
    REFRESH: {
      ON_Click: CM_ACTIONS.onRefresh,
      LABEL: 'REFRESH',
      ICON: 'images/icons_refresh.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_refresh.svg',
      ARGS: [
        ARGS_CM.PROPS.ASSETS,
        ARGS_CM.PROPS.ON_REFRESH,
        ARGS_CM.PROPS.EXT_DETAILS,
        ARGS_CM.PROPS.CLOSE_CONTEXT_MENU
      ],
      PREDICATES: CM_PREDICATES.isShowRefresh
    },
    [UIActions.REMOVE_FROM_COLLECTION]: {
      ON_Click: CM_ACTIONS.onSetModalAction,
      LABEL: 'REMOVE_FROM_COLLECTION',
      ICON: 'images/icons_removeFromCol.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_removeFromCol.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.SET_MODAL, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowRemoveFromCollection
    },
    [UIActions.DELINK]: {
      ON_Click: CM_ACTIONS.onRunDelinkQuery,
      LABEL: 'REMOVE_WORKING_COPY_MENU',
      ICON: 'images/icons_delink.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_delink.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.GET_PROCESS_ON_QUERY, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowRemoveWorkingCopy
    },
    [UIActions.RENAME]: {
      ON_Click: CM_ACTIONS.onSetModalAction,
      LABEL: 'RENAME_LABEL',
      ICON: 'images/icons_rename.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_rename.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.SET_MODAL, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowRename
    },
    [UIActions.RESTORE]: {
      ON_Click: CM_ACTIONS.onRestoreLowResAndDirect,
      LABEL: 'RESTORE',
      ICON: 'images/icons_restore.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_restore.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowArchiveRestoreOption
    },
    [UIActions.RESURRECT]: {
      ON_Click: CM_ACTIONS.onResurrect,
      LABEL: 'RESURRECT',
      ICON: 'images/icons_resurrect.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_resurrect.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.GET_PROCESS_ON_QUERY, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowResurrect
    },
    [UIActions.REVEAL_IN_EXPLORER]: {
      ON_Click: CM_ACTIONS.onRunRevealExecQuery,
      LABEL: OsUtil.isMAC() ? 'REVEAL_IN_FINDER' : 'REVEAL_IN_EXPLORER',
      ICON: 'images/icons_open.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_open.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowInSystem
    },
    S3UPLOAD: {
      ON_Click: CM_ACTIONS.onSetModalAction,
      LABEL: 'INGEST_TO_ZOOM',
      ICON: 'images/icons_ingest.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_ingest.svg',
      ARGS: [ARGS_CM.PROPS.EXT_DETAILS, ARGS_CM.PROPS.SET_MODAL, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowIngestToZoom
    },
    [UIActions.SHARE_AND_DOWNLOAD]: {
      ON_Click: CM_ACTIONS.onDownload,
      LABEL: 'SHARE_AND_DOWNLOAD',
      ICON: 'images/icons_share.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_share.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowShareAndDownload
    },
    [UIActions.VIEW_IN_ASSET_BROWSER]: {
      ON_Click: CM_ACTIONS.onShowOnLegacyBrowser,
      LABEL: 'Show in Asset Browser',
      ICON: 'images/icons_open.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_open.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowInAssetBrowser
    },
    [UIActions.SMART_COPY]: {
      ON_Click: CM_ACTIONS.onSetModalAction,
      LABEL: 'SMART_COPY',
      ICON: 'images/icons_smartcopy2.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_smartcopy2.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.SET_MODAL, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowSmartCopy
    },
    [UIActions.SMART_LINK]: {
      ON_Click: CM_ACTIONS.onSetModalAction,
      LABEL: 'SMART_LINK',
      ICON: 'images/icons_smartlink2.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_smartlink2.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.SET_MODAL, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowSmartLink
    },
    STATUS: {
      ON_Click: null,
      LABEL: null,
      ARGS: [
        ARGS_CM.PROPS.ASSETS,
        ARGS_CM.PROPS.GET_PROCESS_ON_QUERY,
        ARGS_CM.PROPS.CLOSE_CONTEXT_MENU,
        ARGS_CM.PROPS.EXCLUDED_ACTIONS_LIST
      ],
      PREDICATES: CM_PREDICATES.isShowStatus
    },
    [UIActions.UNLOCK]: {
      ON_Click: CM_ACTIONS.onUnLock,
      LABEL: 'UNLOCK',
      ICON: 'images/icons_unlock.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_unlock.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.GET_PROCESS_ON_QUERY, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowUnLock
    },
    [UIActions.ADD_TO_FAVORITES]: {
      ON_Click: CM_ACTIONS.onAddOrRemoveFromFavorite,
      LABEL: 'MARK_AS_FAVORITE',
      ICON: 'images/icons_addToFav.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_addToFav.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowAddToFavorite
    },
    [UIActions.REMOVE_FROM_FAVORITES]: {
      ON_Click: CM_ACTIONS.onAddOrRemoveFromFavorite,
      LABEL: 'REMOVE_FROM_FAVORITE',
      ICON: 'images/icons_addToFav.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_addToFav.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowRemoveFromFavorite
    },
    [UIActions.CREATE_BIN]: {
      ON_Click: CM_ACTIONS.onSetModalAction,
      LABEL: 'CREATE_BIN',
      ICON: 'images/icons_create_bin.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_create_bin.svg',
      ARGS: [ARGS_CM.PROPS.COLLECTION, ARGS_CM.PROPS.SET_MODAL, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU, ARGS_CM.PROPS.SELECTED_COLLECTIONS],
      PREDICATES: CM_PREDICATES.isCreateBin
    },
    [UIActions.MOVE_TO_BIN]: {
      LABEL: 'MOVE_TO_BIN',
      ICON: 'images/icons_fileDetails.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_fileDetails.svg',
      ARGS: [ARGS_CM.PROPS.COLLECTION, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU, ARGS_CM.PROPS.SELECTED_COLLECTIONS],
      PREDICATES: CM_PREDICATES.isShowMoveToBin
    },
    [UIActions.REMOVE_FROM_BIN]: {
      ON_Click: CM_ACTIONS.onRemoveFromBin,
      LABEL: 'REMOVE_FROM_BIN',
      ICON: 'images/icons_delete_coll.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_delete_coll.svg',
      ARGS: [ARGS_CM.PROPS.COLLECTION, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU, ARGS_CM.PROPS.SELECTED_COLLECTIONS],
      PREDICATES: CM_PREDICATES.isShowRemoveFromBin
    },
    [UIActions.RENAME_BIN]: {
      ON_Click: CM_ACTIONS.onSetModalAction,
      LABEL: 'RENAME_BIN',
      ICON: 'images/icons_rename.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_rename.svg',
      ARGS: [ARGS_CM.PROPS.COLLECTION, ARGS_CM.PROPS.SET_MODAL, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU, ARGS_CM.PROPS.SELECTED_COLLECTIONS],
      PREDICATES: CM_PREDICATES.canRenameBin
    },
    [UIActions.RENAME_COLLECTION]: {
      ON_Click: CM_ACTIONS.onSetModalAction,
      LABEL: 'RENAME_COLLECTION',
      ICON: 'images/icons_rename.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_rename.svg',
      ARGS: [ARGS_CM.PROPS.COLLECTION, ARGS_CM.PROPS.SET_MODAL, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU, ARGS_CM.PROPS.SELECTED_COLLECTIONS],
      PREDICATES: CM_PREDICATES.canRenameCollection
    },
    [UIActions.HIDE_COLLECTION]: {
      ON_Click: CM_ACTIONS.onSetModalAction,
      LABEL: 'HIDE_COLLECTION',
      ICON: 'images/icons_hide.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_hide.svg',
      ARGS: [ARGS_CM.PROPS.COLLECTION, ARGS_CM.PROPS.SET_MODAL, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU, ARGS_CM.PROPS.SELECTED_COLLECTIONS],
      PREDICATES: CM_PREDICATES.canHideCollection
    },
    [UIActions.UNHIDE_COLLECTION]: {
      ON_Click: CM_ACTIONS.onSetModalAction,
      LABEL: 'UNHIDE_COLLECTION',
      ICON: 'images/icons_unhide.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_unhide.svg',
      ARGS: [ARGS_CM.PROPS.COLLECTION, ARGS_CM.PROPS.SET_MODAL, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU, ARGS_CM.PROPS.SELECTED_COLLECTIONS],
      PREDICATES: CM_PREDICATES.canUnhideCollection
    },
    [UIActions.DELETE_COLLECTION]: {
      ON_Click: CM_ACTIONS.onSetModalAction,
      LABEL: 'DELETE_COLLECTION',
      ICON: 'images/icons_delete_coll.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_delete_coll.svg',
      ARGS: [ARGS_CM.PROPS.COLLECTION, ARGS_CM.PROPS.SET_MODAL, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU, ARGS_CM.PROPS.SELECTED_COLLECTIONS],
      PREDICATES: CM_PREDICATES.canDeleteCollection
    },
    [UIActions.DELETE_BIN]: {
      ON_Click: CM_ACTIONS.onSetModalAction,
      LABEL: 'DELETE_BIN',
      ICON: 'images/icons_delete_coll.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_delete_coll.svg',
      ARGS: [ARGS_CM.PROPS.COLLECTION, ARGS_CM.PROPS.SET_MODAL, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU, ARGS_CM.PROPS.SELECTED_COLLECTIONS],
      PREDICATES: CM_PREDICATES.canDeleteBin
    },
    [UIActions.REACTIVATE_BIN]: {
      ON_Click: CM_ACTIONS.onReactivateBin,
      LABEL: 'REACTIVATE_BIN',
      ICON: 'images/icons_unhide.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_unhide.svg',
      ARGS: [ARGS_CM.PROPS.COLLECTION, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU, ARGS_CM.PROPS.SELECTED_COLLECTIONS],
      PREDICATES: CM_PREDICATES.isShowReactivateBin
    },
    [UIActions.REACTIVATE_COLLECTION]: {
      ON_Click: CM_ACTIONS.onReactivateCollection,
      LABEL: 'REACTIVATE_COLLECTION',
      ICON: 'images/icons_unhide.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_unhide.svg',
      ARGS: [ARGS_CM.PROPS.COLLECTION, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU, ARGS_CM.PROPS.SELECTED_COLLECTIONS],
      PREDICATES: CM_PREDICATES.isShowReactivateCollection
    },
    [UIActions.DOWNLOAD]: {
      ON_Click: CM_ACTIONS.onCollectionAssetDownload,
      LABEL: 'DOWNLOAD',
      ICON: 'images/icons_download.svg',
      ICON_On_Hover: 'hoverIcons/context/icons_download.svg',
      ARGS: [ARGS_CM.PROPS.ASSETS, ARGS_CM.PROPS.CLOSE_CONTEXT_MENU],
      PREDICATES: CM_PREDICATES.isShowDownload
    }
  },
  KEYS: [
    'STATUS', //Todo: Break down Status into different actions.
    UIActions.DELINK,
    UIActions.LOCK,
    UIActions.UNLOCK,
    {
      key: t('MANAGE_EXTERNAL_ASSET'),
      value: MANAGE_EXTERNAL_FILE_KEYS,
      icons: { icon: 'images/icons_externalAsset.svg', iconOnHover: 'hoverIcons/context/icons_externalAsset.svg' }
    },
    UIActions.RENAME,
    UIActions.EDIT_METADATA,
    UIActions.EDIT_MENU,
    UIActions.COMPARE_VIEW,
    UIActions.ARCHIVE,
    UIActions.RESTORE,
    UIActions.DELETE,
    UIActions.RESURRECT,
    UIActions.PURGE,
    UIActions.SMART_COPY,
    UIActions.SMART_LINK,
    UIActions.ADD_TO_COLLECTION,
    UIActions.REMOVE_FROM_COLLECTION,
    UIActions.VIEW_ASSET,
    UIActions.SHARE_AND_DOWNLOAD,
    UIActions.SHARE_VIA_EMAIL,
    {
      key: t('MORE'),
      value: MORE_KEYS,
      icons: { icon: 'images/icons_more.svg', iconOnHover: 'hoverIcons/context/icons_more.svg' }
    }
  ],
  EXTERNAL_FILE_KEYS: [
    'REFRESH',
    'S3UPLOAD', //Implement this in backend
    UIActions.ASSET_DETAILS //External File Info & Implement this in backend
  ],
  COLLECTION_KEYS: [
    UIActions.CREATE_BIN,
    {
      key: UIActions.MOVE_TO_BIN,
      component: MoveToBinSubMenu,
      icons: { icon: 'images/icons_fileDetails.svg', iconOnHover: 'hoverIcons/context/icons_fileDetails.svg' }
    },
    UIActions.REMOVE_FROM_BIN,
    UIActions.RENAME_BIN,
    UIActions.RENAME_COLLECTION,
    UIActions.HIDE_COLLECTION,
    UIActions.UNHIDE_COLLECTION,
    UIActions.DELETE_COLLECTION,
    UIActions.DELETE_BIN,
    //UIActions.REACTIVATE_BIN,
    UIActions.REACTIVATE_COLLECTION
  ],
  COLLECTION_ASSETS_KEYS: [
    UIActions.DOWNLOAD,
    UIActions.VIEW_ASSET,
    UIActions.RENAME,
    UIActions.REMOVE_FROM_COLLECTION,
    UIActions.COPY_ASSET_ID,
    UIActions.COPY_ASSET_PATH,
    UIActions.VIEW_IN_ASSET_BROWSER
  ]
  /*renderMoveBinSubMenuCompoent: (collection, ) => {
    return <NewCollectionModal collection = {collection} />;
  }*/
};
